import React, { useEffect, useState } from "react";
import { Alert, Spin } from "antd";
import {
  fetchProjectDocumentationFileBlob,
  parseTextBlobForPreview,
} from "../../../app/utils/common/projectDocumentationFile";
import "./ProjectDocumentationTextViewer.scss";

/**
 * Read-only plain text preview for .txt, .env, and .json project documentation files.
 */
const ProjectDocumentationTextViewer = ({
  documentId,
  fileDocumentId,
  onLoadError,
  compact = false,
  formatJson = false,
}) => {
  const [loading, setLoading] = useState(true);
  const [text, setText] = useState("");
  const [loadError, setLoadError] = useState(null);
  const onLoadErrorRef = React.useRef(onLoadError);
  onLoadErrorRef.current = onLoadError;

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setLoadError(null);
    setText("");

    (async () => {
      try {
        const blob = await fetchProjectDocumentationFileBlob(documentId, fileDocumentId);
        const content = await parseTextBlobForPreview(blob, { formatJson });
        if (!cancelled) setText(content);
      } catch (e) {
        if (!cancelled) {
          setLoadError(e?.message || "Could not load the text file.");
          onLoadErrorRef.current?.(e);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [documentId, fileDocumentId, formatJson]);

  if (loading) {
    return (
      <div className={`project-doc-text-viewer ${compact ? "project-doc-text-viewer--compact" : ""}`}>
        <div className="flex justify-center py-12">
          <Spin />
        </div>
      </div>
    );
  }

  if (loadError) {
    return (
      <div className={`project-doc-text-viewer ${compact ? "project-doc-text-viewer--compact" : ""}`}>
        <Alert type="error" showIcon message={loadError} />
      </div>
    );
  }

  return (
    <pre className={`project-doc-text-viewer ${compact ? "project-doc-text-viewer--compact" : ""}`}>
      {text}
    </pre>
  );
};

export default ProjectDocumentationTextViewer;
